import {applicationActionTypes} from '../actions/application-action-types';
import {applicationViewModes} from '../actions/application-view-modes';

const initialApplicationState = {
  authorizationState: {},
  selectEnabled: false,
  applicationViewMode: applicationViewModes.APPLICATION_VIEW_ALBUMS,
  headerMenuExpanded: false,
  leftNavigation: true,
  isLoading: false,
  userSubscriptionExpired: false,
  window: {
    height:0,
    width:0
  }
};

export const applicationState = (state = initialApplicationState, action) => {
  switch (action.type) {
    case applicationActionTypes.APPLICATION_SELECTION_MODE:
      return {...state, selectEnabled: action.selectEnabled, applicationViewMode: action.viewMode};
    case applicationActionTypes.APPLICATION_TOGGLE_HEADER_NAVIGATION:
      return {...state, headerMenuExpanded: !state.headerMenuExpanded};
    case applicationActionTypes.APPLICATION_LEFT_NAVIGATION:
      return {...state, leftNavigation: action.shown};
    case applicationActionTypes.APPLICATION_REMOTE_LOADING:
      return {...state, isLoading: action.isLoading};
    case applicationActionTypes.AUTHORIZATION_TOKEN_DATA:
      return { ...state, authorizationState: action.payload };
    case applicationActionTypes.APPLICATION_SCREEN_SIZE_UPDATE:{
      const window = {height: action.height, width:action.width};
      return { ...state, window: window };
    }
    case applicationActionTypes.USER_SUBSCRIPTION_EXPIRED:
      return { ...state, userSubscriptionExpired: action.expired };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/settings/reducers/application-state-reducers.js